var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"slider",staticClass:"carousel-slider"},[_c('div',{staticClass:"carousel-track"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index},[_vm._t("default",null,{"index":index,"item":item})],2)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }